__turbopack_context__.v({
  "className": "graphikextended_b2b806f-module__YxDAoq__className",
  "variable": "graphikextended_b2b806f-module__YxDAoq__variable",
});
